var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('Page',{attrs:{"title":"My Favorites"}},[_c('BizList',{attrs:{"bizs":_vm.bizs,"loading":_vm.loading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }